<template>
    <div>
        <div class="container">
            <div class="activity-title">活动信息</div>
            <div class="flex activity-wrapper margin-b20">
                <div class="activity-tip">活动名称：{{activityInfo.activityName}}</div>
                <div class="activity-tip">活动起止时间：{{activityInfo.startTime +' 至 ' +activityInfo.endTime}}</div>
            </div>
            <div  class="activity-tip">活动描述：{{activityInfo.remark}}</div>
        </div>
        <div class="container">
            <div class="activity-title">企业信息</div>
            <div class="activity-tip margin-b20">企业名称：{{userInfo.companyName}}</div>
            <div class="activity-tip margin-b20 flex">企业logo：
                <multi-image-upload
                        :uploadUrl="activityFileUpload"
                        :url="imageUrls"
                        :imageSize="1"
                        @handleimgInfo="handleimgInfo"
                        :verify="true"
                />
            </div>
            <div class="activity-tip flex">企业成就：
                <el-input
                        style="width: 80%"
                        type="textarea"
                        placeholder="请输入企业成就"
                        v-model="supplierSignUpAO.companyAchievement"
                        maxlength="200"
                        show-word-limit></el-input>
            </div>
        </div>
        <div class="container">
            <div class="activity-title">商品信息</div>
            <e-search
                     :count="5"
                    :data="filterInfo.data"
                    :field-list="filterInfo.fieldList"
                    :width="filterInfo.width"
                    @handleFilter="handleFilter"
                    @handleReset="handleReset"></e-search>
            <div class="supplier-merchandise">供应商商品</div>

            <TableList
                ref="multipleTable"
                :table-label="tableLabel"
                :table-data="tableData"
                :reserveSelection="reserveSelection"
                :rowKey="rowKey"
                :selectionShow="selectionShow"
                 :defaultSelectionArray="defaultSelectionArray"
                :defaultSelect="defaultSelect"
                @handleSelectionChange="handleSelectionChange">
                <template v-slot:productPictUrl="slot">
                    <el-image
                            class="default-img"
                            v-if="slot.scope.row.productPictUrl"
                            :src="slot.scope.row.productPictUrl"
                            :preview-src-list="[slot.scope.row.productPictUrl]">
                        <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                </template>
            </TableList>
            <div class="pagination">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[10, 20, 30]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page="queryData.pageNum"
                        :page-size="queryData.pageSize"
                        :total="queryData.pageTotal"
                        prev-text="上一页"
                        next-text="下一页"
                ></el-pagination>
            </div>
         </div>
        <div class="button-wrapper">
            <div class="back" @click="toBack">返 回</div>
            <div class="save" @click="saveSupplierSignUp">保 存</div>
            <div class="save submit-aduit" @click="submitSupplierSignUp" >提交报名审核</div>
        </div>
    </div>
</template>

<script>
    import multiImageUpload from '../../components/fileUpload/multiImageUpload';
     import eSearch from "../../components/common/e-search";
    import TableList from '../../components/common/e-table-list';
    import api from '../../api/cms/index';
    export default {
        components:{multiImageUpload,eSearch,TableList},
        data(){
            return{
                selectionShow:true,
                reserveSelection:true,
                activityFileUpload:api.activityFileUpload,
                id:'',//就是activityId
                userInfo:{},
                activityInfo:{},
                queryData:{
                    supplierCompanyId:null,
                    brandName:null,
                    skuName:null,
                    categoryName:null,
                    skuCode:null,
                    pageNum:1,
                    pageSize:10,
                    pageTotal:0,
                },
                defaultSelect: false,
                defaultSelectionArray: [],
                rowKey:'skuId',
                tableData: [],
                tableLabel: [
                    {label: "图片", slot: "productPictUrl", align: "center",width:'90'},
                    {label: "商品名称", param: "skuName", align: "center"},
                    {label: "商品编号", param: "skuCode", align: "center"},
                    {label: "品牌", param: "brandName", align: "center",width:'140'},
                    {label: "所属分类", param: "categoryName", align: "center",width:'200'},
                ],
                filterInfo: {
                    data: {
                        brandName:null,
                        skuName:null,
                        categoryName:null,
                        skuCode:null,
                    },
                    fieldList: [
                        {label: "查询品牌", type: "input", value: "brandName"},
                        {label: "商品名称", type: "input", value: "skuName"},
                        {label: "商品分类", type: "input", value: "categoryName"},
                        {label: "商品编号", type: "input", value: "skuCode"},
                    ],
                    /**配置项 */
                    btnStyle: [
                        {
                            icon: "el-icon-search",
                            text: "过滤",
                            type: "primary"
                        },
                        {
                            icon: "el-icon-refresh",
                            text: "重置"
                        }
                    ]
                },
                selectData:[],
                // 图片
                imageUrls: [],
                fileUploadUrl:'',
                fileList: [],  // pdf回显列表
                supplierSignUpAO:{
                    activityId:this.id,
                    companyAchievement:'',
                    companyLogo:'',
                    companyName:'',
                    id:'',
                    productIds:[],
                },
            }
        },
        methods:{
            handleSelectionChange(val){
                this.selectData= val.map(item=>item.skuId);
                this.supplierSignUpAO.productIds = this.selectData.toString();
             },
            toBack(){
                this.$router.back();
            },
            //保存
           async saveSupplierSignUp(){
                if(this.selectData.length === 0 ){
                    this.$message.warning('请选择需要上传的商品');
                    return false;
                }

                await api.saveSupplierSignUp(this.supplierSignUpAO).then((res) => {
                    if (res.code === "200") {
                      this.$message.success('保存成功');
                      this.toBack();
                    }
                });
            },
            //提交报名审核
            async submitSupplierSignUp(){
                if(this.selectData.length === 0 ){
                    this.$message.warning('请选择需要上传的商品');
                    return false;
                }
                await api.submitSupplierSignUp(this.supplierSignUpAO).then((res) => {
                    if (res.code === "200") {
                        this.$message.success('提交成功');
                        this.toBack();
                    }
                });
            },
            handleSizeChange(val){
                this.queryData.pageNum=1;
                this.queryData.pageSize=val;
                this.querySkuListBySkuDTO();
            },
            handleCurrentChange(val){
                this.queryData.pageNum=val;
                this.querySkuListBySkuDTO();
            },
            handleFilter(val){
                this.queryData.brandName=val.brandName;
                this.queryData.skuName=val.skuName;
                this.queryData.categoryName=val.categoryName;
                this.queryData.skuCode=val.skuCode;
                this.queryData.pageNum = 1;
                this.querySkuListBySkuDTO();
            },
            handleReset(){
                this.queryData = {
                        supplierCompanyId:this.userInfo.companyId,
                        brandName:null,
                        skuName:null,
                        categoryName:null,
                        skuCode:null,
                        pageNum:1,
                        pageSize:10,
                        pageTotal:0,
                }
                this.querySkuListBySkuDTO();
            },
            // 获取上传文件
            getFileInfo(file) {
                console.log(file, "fffff");
              },
            handleimgInfo(val){
                  this.supplierSignUpAO.companyLogo = val[0];
            },
            //查询活动信息
            async queryActivityInfo(){
               await api.queryActivityInfo({id:this.id}).then((res) => {
                    if (res.code === "200") {
                       this.activityInfo = res.data || {};
                    }
                });
            },
            async querySkuListBySkuDTO(){
                await api.querySkuListBySkuDTO(this.queryData).then((res) => {
                    if (res.code === "200") {
                        this.tableData = res.data.records || [];
                        this.queryData.pageTotal = res.data.total || 0;
                        this.queryCompanyEnrollInfo();//判断是否是 保存了， 有data就保存了，没有就是没保存
                     }
                });
            },
            async queryCompanyEnrollInfo(){
                await api.queryCompanyEnrollInfo({activityId:this.id}).then((res) => {
                    let dataLen =Object.keys(res.data).length ;
                     if (res.code === "200" && dataLen !== 0) {
                          this.supplierSignUpAO.companyLogo = res.data.companyLogo;
                          this.imageUrls = [res.data.companyLogo];
                          //默认选中
                           this.defaultSelectionArray = res.data.skuDTOIPage.records.map(item=>item.skuId)
                           this.defaultSelect = true;
                           this.supplierSignUpAO.companyAchievement = res.data.companyAchievement;
                     }else {
                         this.defaultSelect = false;
                         this.defaultSelectionArray = [];
                     }
                });
            },
        },
        mounted() {
            this.userInfo = JSON.parse(localStorage.getItem('USERINFO'));
            this.queryData.supplierCompanyId = this.userInfo.companyId;
            this.id = this.$route.query.id;
            this.supplierSignUpAO.activityId = this.$route.query.id;
            this.supplierSignUpAO.companyName = this.userInfo.companyName;
            this.queryActivityInfo();
            this.querySkuListBySkuDTO();//查询活动商品
        }
    }
</script>

<style scoped lang="scss">
    .button-wrapper{
        display: flex;
        justify-content: center;
        font-size: 14px;
        margin-top: 20px;
        .back{
            cursor: pointer;
            padding: 8px 24px;
            background-color: #fff;
            border: 1px solid #C5C5C5;
            margin-right: 20px;
        }
        .save{
            cursor: pointer;
            background: #2587FF;
            padding: 8px 24px;
            color: #fff;
            margin-right: 20px;

        }
        .submit-aduit{
            padding: 8px 18px;
        }

    }
    .default-img{
        width: 48px;
     }
    .supplier-merchandise{
        width: 176px;
        height: 40px;
        line-height: 40px;
        background-color: #F8F8F8;
        text-align: center;
        border: 1px solid #D9D9D9;
        border-bottom: none;
    }
    .activity-title {
        font-weight: 500;
        font-size: 16px;
        color: #333;
        margin-bottom: 20px;
    }
    .activity-wrapper{
        div{
            width: 50%;
        }
    }
    .activity-tip {
        font-size: 14px;
     }
</style>